import { graphql } from "../gql";

export const versionReportMutationDoc = graphql(`
  mutation versionReport(
    $reportId: UUID!
    $reportSubtype: AuditFindingReportSubtype!
    $reportType: AuditFindingReportType!
  ) {
    versionReport(
      reportId: $reportId
      reportSubtype: $reportSubtype
      reportType: $reportType
    ) {
      auditFindingReportId
      auditFindingReportViewId
      reportUrl
    }
  }
`);
